<mat-card appearance="outlined" class="card-header form-field-density-4">
  <!--mat-card-header>
    <mat-card-title>
      <div class="view-component-title">
        <span class="title">Importação de Dados - JSON</span>
      </div>
    </mat-card-title>
  </mat-card-header--> 

  <div fxLayout="row"  fxLayoutAlign="start center" class="headerRow">
    <mat-icon color="primary">info</mat-icon>
    <span style="margin-left: 5px;"><strong>Configuração em Execução:</strong> {{ headerText || 'Selecione uma configuração para executar.' }}</span>
  </div>

  <mat-card-content style="margin-top: 10px">
    <div fxLayout="row" fxLayoutGap="10px" class="form-field-density-4">
      <mat-form-field *ngIf="uas.user.companylist.length > 1">
        <mat-label>Escolher uma Empresa</mat-label>
        <mat-select [disabled]="disabled" [(ngModel)]="codecompany" (selectionChange)="getActiveCompanies()">
          <mat-option *ngFor="let data of uas.user.companylist" [value]="data.codecompany">
            {{ data.codecompany }} - {{ data.companyname }}
          </mat-option>
        </mat-select>
      </mat-form-field>   
      <div fxLayout="row">        
        <button mat-raised-button color="primary" class="button-margin my-button-class" (click)="loadConfigs()">
          <mat-icon>settings</mat-icon> Buscar configurações
        </button>                        
      </div>        
    </div>
  </mat-card-content>
</mat-card>

<div class="view-component form-field-density-4">
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" ngClass="custom-tabs combined-tab">
    <mat-tab id="Mktpjsonrule">
      <ng-template mat-tab-label>
        Configurações
      </ng-template>

      
      <div class="card-grid">
        <mat-card *ngFor="let conf of configs" class="config-card">
          <img mat-card-image [src]="conf.IMAGE || ''" (error)="conf.imageError = true" *ngIf="!conf.imageError; else noImage">
          <ng-template #noImage>
            <div class="no-image">
              <mat-icon>image_not_supported</mat-icon>
            </div>
          </ng-template>

         <mat-card-title>
          <div class="integration-header">
            <span class="integration-name" matTooltip="{{ conf.NAME }}">{{ conf.NAME || 'Sem nome' }}</span>
          </div>
        </mat-card-title>


          <mat-card-content>
            <div class="param-info">
              <mat-icon>tune</mat-icon>
              <span>{{ conf.config.parameters?.length || 0 }} parâmetro(s)</span>
            </div>
          </mat-card-content>

        <mat-card-actions class="card-actions-row">
          <button mat-raised-button color="primary" class="execute-button" [disabled]="conf.status === 'processing'" (click)="onExecute(conf)">
            <span class="btn-content">
              <ng-container [ngSwitch]="conf.status">
                <mat-icon *ngSwitchCase="'idle'">play_arrow</mat-icon>
                <mat-spinner *ngSwitchCase="'processing'" diameter="20" strokeWidth="3"></mat-spinner>
                <mat-icon *ngSwitchCase="'success'" color="primary">check_circle</mat-icon>                
                <mat-icon *ngSwitchCase="'error'" color="warn">error</mat-icon>
              </ng-container>
              <span class="btn-label">
                {{
                  conf.status === 'processing' ? 'Executando...' :
                  conf.status === 'success' ? 'Concluído' :
                  conf.status === 'error' ? 'Erro' : 'Executar'
                }}
              </span>
            </span>
          </button>
        </mat-card-actions>
          <div class="status-info">
            <div class="time-info" *ngIf="conf.duration">
              ⏱ Tempo: {{ conf.duration }}s
            </div>

            <div class="error-info" *ngIf="conf.errorMsg">
              <mat-icon
                color="warn"
                matTooltip="{{ conf.errorMsg }}"
                class="error-icon"
              >error</mat-icon>

              <button mat-button class="error-copy-link" (click)="copyToClipboard(conf.errorMsg)">
                Copiar erro
              </button>
            </div>
         </div>
        </mat-card>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<!-- Dialog para preencher parâmetros input -->
<ng-template #inputDialog let-data>
  <h2 mat-dialog-title class="param-modal-title">Preencher Parâmetros</h2>

  <mat-dialog-content class="param-modal-content">
    <mat-accordion multi>
      <mat-expansion-panel *ngFor="let param of data.parameters">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="param-name">{{'@'}}{{ param.PARNAME }}</span>
          </mat-panel-title>
          <mat-panel-description>
            {{ param.TYPE === 'I' ? 'Entrada do usuário' : 'Outro tipo' }}
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="param-input" *ngIf="param.TYPE !== 'D' && param.TYPE !== 'S'">
          <mat-form-field appearance="outline" class="full-width">
            <textarea
              *ngIf="isMultiline(param.VALUE)"
              matInput
              rows="4"
              [(ngModel)]="param.VALUE"
              placeholder="Digite o valor para @{{ param.PARNAME }}"
            ></textarea>

            <input
              *ngIf="!isMultiline(param.VALUE)"
              matInput
              [(ngModel)]="param.VALUE"
              placeholder="Digite o valor para @{{ param.PARNAME }}"
            />
          </mat-form-field>
        </div>
        <div class="param-input" *ngIf="param.TYPE === 'S'">
              <search-input-new [(ngModel)]="param.VALUE" [searchProperties]="{
                placeholder: 'Pesquisar valor...',
                size: 'large',
                showKey: true,
                disabled: false,
                entityName:param.ENTITYNAME.value,
                fields: {
                  keyField: param.KEYFIELD.value,
                  valueField: param.VALUEFIELD.value
                }
              }"></search-input-new>   
        </div>
        <div class="param-input" *ngIf="param.TYPE === 'D'">
          
          <nz-upload
            [nzCustomRequest]="customUpload"
            nzName="arquivo"
            [nzShowUploadList]="true"
            [nzMultiple]="true"
            [nzWithCredentials]="false"
            [nzBeforeUpload]="beforeUpload"
            (nzChange)="onChange($event)"
            >
              <button nz-button>
                <i nz-icon nzType="upload"></i>
                Selecionar Arquivo
              </button>
            </nz-upload>
            <mat-divider></mat-divider>
            <div class="directory-class"> 
              <button nz-button nzType="primary" [nzLoading]="loadingDirectory" (click)="openDirectory()">Selecionar pasta</button>
              <p>Diretório: {{directoryPath}} | Total de Arquivos: {{directoryfileList.length}}</p>
            </div>
        </div>
        
      </mat-expansion-panel>
    </mat-accordion>
  </mat-dialog-content>

<mat-dialog-actions align="end" class="param-modal-actions">
  <button mat-button (click)="closeDialog()" >Cancelar</button>
  <button mat-raised-button color="primary" color="success" (click)="validateAndSubmit()">Executar</button>
</mat-dialog-actions>
</ng-template>